import * as types from '@/store/types'
import { redirectToBackOrHome } from '@/utils/common'

export default function loadSession({ from, next, store }) {
  const { isProfileLoaded } = store.getters

  if (!isProfileLoaded) {
    return store
      .dispatch(types.ADD_ACTION_IN_QUEUE, {
        type: types.GET_SESSION_ACCOUNT,
        name: types.SESSION
      })
      .then(() => next())
      .catch(() => {
        store.dispatch(types.REMOVE_SESSION).finally(() => redirectToBackOrHome(from, next))
      })
  }

  return next()
}
